import useLenis from "@/hooks/useLenis";
import { QuoteProvider } from "@/context/QuoteContext";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Products from "@/components/site/Products";
import About from "@/components/site/About";
import Testimonials from "@/components/site/Testimonials";
import SelfService from "@/components/site/SelfService";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  useLenis();
  return (
    <QuoteProvider>
      <div className="min-h-screen bg-brand-cream">
        <Header />
        <main>
          <Hero />
          <Marquee />
          <Products />
          <About />
          <Testimonials />
          <SelfService />
          <FAQ />
          <Contact />
        </main>
        <Footer />
      </div>
    </QuoteProvider>
  );
}
